'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Spinner = exports.StatelessSpinner = exports.enhance = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n\n  animation: ', ';\n  animation-fill-mode: backwards;\n'], ['\n  ', '\n\n  animation: ', ';\n  animation-fill-mode: backwards;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _progress_bar = require('react-toolbox/lib/progress_bar');

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _lifecycle = require('recompose/lifecycle');

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _animation = require('styled-material/dist/src/animation');

var _colors = require('styled-material/dist/src/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var SpinnerContainer = _styledComponents2.default.div(_templateObject, function (_ref) {
    var center = _ref.center;
    return center && '\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  ';
}, _animation.fadeIn);
var StyledProgressBar = (0, _styledComponents2.default)(_progress_bar2.default)(_templateObject2, function (_ref2) {
    var size = _ref2.size,
        type = _ref2.type;
    return type === 'circular' && '\n    width: ' + size + 'px !important;\n    height: ' + size + 'px !important;\n  ';
});
var enhance = exports.enhance = (0, _compose2.default)((0, _withState2.default)('visible', 'setVisible', false), (0, _lifecycle2.default)({
    componentDidMount: function componentDidMount() {
        var _this = this;

        var timeout = this.props.timeout;

        if (timeout !== false) {
            this.timeout = setTimeout(function () {
                _this.props.setVisible(true);
            }, timeout === undefined ? 300 : timeout);
        }
    },
    componentWillUnmount: function componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }
}));
var StatelessSpinner = exports.StatelessSpinner = function StatelessSpinner(_a) {
    var _a$size = _a.size,
        size = _a$size === undefined ? 28 : _a$size,
        _a$background = _a.background,
        background = _a$background === undefined ? false : _a$background,
        center = _a.center,
        timeout = _a.timeout,
        visible = _a.visible,
        props = __rest(_a, ["size", "background", "center", "timeout", "visible"]);

    return React.createElement(SpinnerContainer, { center: center, style: background && {
            backgroundColor: background === true ? 'white' : (0, _colors.normalizeColor)(background)
        } || {} }, (timeout === false || visible) && React.createElement(StyledProgressBar, __assign({}, props, { size: size })));
};
var Spinner = exports.Spinner = enhance(StatelessSpinner);
//# sourceMappingURL=spinner.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toolbox-components/dist/src/spinner.js
 ** module id = 638
 ** module chunks = 0
 **/